import { lazy } from 'react';
import * as routePath from '../route-path';
import * as routeName from '../route-name';
import { AudienceIcon } from 'components/Atoms/Icon';
import { USER_LEVEL_TYPE } from 'constants/common';
import { t } from 'utilities/lang';

const Audiences = lazy(() =>
  import('components/Pages/Library/components/Audiences')
);

const CreateAudience = lazy(() =>
  import(
    'components/Pages/Library/components/Audiences/components/CreateAudience'
  )
);

const AudienceStandard = lazy(() =>
  import(
    'components/Pages/Library/components/Audiences/components/CreateAudience/components/Standard'
  )
);

const CustomTargeting = lazy(() =>
  import(
    'components/Pages/Library/components/Audiences/components/CreateAudience/components/Custom'
  )
);

const PersonalDataTargeting = lazy(() =>
  import(
    'components/Pages/Library/components/Audiences/components/CreateAudience/components/PersonalDataTargeting'
  )
);

const AudienceRetargeting = lazy(() =>
  import(
    'components/Pages/Library/components/Audiences/components/CreateAudience/components/Retargeting'
  )
);

export const audiencesRoutes = [
  {
    path: routePath.AUDIENCES,
    component: Audiences,
    exact: true,
    showMenu: true,
    name: `${t('route.my')} ${routeName.AUDIENCES}`,
    breadcrumbs: [{ name: routeName.LIBRARY }, { name: routeName.AUDIENCES }],
    icon: AudienceIcon,
    roles: [USER_LEVEL_TYPE.ADMIN, USER_LEVEL_TYPE.CAMPAIGN_MANAGER],
  },
  {
    path: routePath.CREATE_AUDIENCE,
    component: CreateAudience,
    exact: true,
    parentName: routeName.AUDIENCES,
    breadcrumbs: [
      { name: routeName.LIBRARY },
      { name: routeName.AUDIENCES, link: routePath.AUDIENCES },
      { name: routeName.CREATE_AUDIENCES },
    ],
    roles: [USER_LEVEL_TYPE.ADMIN, USER_LEVEL_TYPE.CAMPAIGN_MANAGER],
  },
  {
    path: routePath.EDIT_AUDIENCE,
    component: CreateAudience,
    exact: true,
    parentName: routeName.AUDIENCES,
    roles: [USER_LEVEL_TYPE.ADMIN, USER_LEVEL_TYPE.CAMPAIGN_MANAGER],
  },
  {
    path: routePath.CREATE_AUDIENCE_STANDARD,
    component: AudienceStandard,
    exact: true,
    parentName: routeName.AUDIENCES,
    breadcrumbs: [
      { name: routeName.LIBRARY },
      { name: routeName.AUDIENCES, link: routePath.AUDIENCES },
      { name: t('common.audience_type.standard_targeting') },
    ],
    roles: [USER_LEVEL_TYPE.ADMIN, USER_LEVEL_TYPE.CAMPAIGN_MANAGER],
  },
  {
    path: routePath.EDIT_AUDIENCE_STANDARD,
    component: AudienceStandard,
    exact: true,
    parentName: routeName.AUDIENCES,
    roles: [USER_LEVEL_TYPE.ADMIN, USER_LEVEL_TYPE.CAMPAIGN_MANAGER],
  },
  {
    path: routePath.CREATE_AUDIENCE_CUSTOM,
    component: CustomTargeting,
    exact: true,
    parentPath: routePath.AUDIENCES,
    breadcrumbs: [
      { name: routeName.LIBRARY },
      { name: routeName.AUDIENCES, link: routePath.AUDIENCES },
      { name: t('common.audience_type.custom_targeting') },
    ],
    roles: [USER_LEVEL_TYPE.ADMIN, USER_LEVEL_TYPE.CAMPAIGN_MANAGER],
  },
  {
    path: routePath.EDIT_AUDIENCE_CUSTOM,
    component: CustomTargeting,
    exact: true,
    parentPath: routePath.CREATE_AUDIENCE_CUSTOM,
    roles: [USER_LEVEL_TYPE.ADMIN, USER_LEVEL_TYPE.CAMPAIGN_MANAGER],
  },
  {
    path: routePath.CREATE_PERSONAL_DATA_TARGETING,
    component: PersonalDataTargeting,
    exact: true,
    parentPath: routePath.CREATE_PERSONAL_DATA_TARGETING,
    breadcrumbs: [
      { name: routeName.LIBRARY },
      { name: routeName.AUDIENCES, link: routePath.AUDIENCES },
      { name: t('common.audience_type.personal_data_targeting') },
    ],
    roles: [USER_LEVEL_TYPE.ADMIN, USER_LEVEL_TYPE.CAMPAIGN_MANAGER],
  },
  {
    path: routePath.EDIT_PERSONAL_DATA_TARGETING,
    component: PersonalDataTargeting,
    exact: true,
    parentPath: routePath.CREATE_PERSONAL_DATA_TARGETING,
    roles: [USER_LEVEL_TYPE.ADMIN, USER_LEVEL_TYPE.CAMPAIGN_MANAGER],
  },
  {
    path: routePath.CREATE_AUDIENCE_RETARGETING,
    component: AudienceRetargeting,
    exact: true,
    parentName: routeName.AUDIENCES,
    breadcrumbs: [
      { name: routeName.LIBRARY },
      { name: routeName.AUDIENCES, link: routePath.AUDIENCES },
      { name: t('common.audience_type.retargeting') },
    ],
    roles: [USER_LEVEL_TYPE.ADMIN, USER_LEVEL_TYPE.CAMPAIGN_MANAGER],
  },
  {
    path: routePath.EDIT_AUDIENCE_RETARGETING,
    component: AudienceRetargeting,
    exact: true,
    parentName: routeName.AUDIENCES,
    roles: [USER_LEVEL_TYPE.ADMIN, USER_LEVEL_TYPE.CAMPAIGN_MANAGER],
  },
];
